<template>
<main class="container-1">

    <div class="container-header">
      <Breadcrumb :links="routesBread" />
      <!-- <h2>Listado</h2> -->
      <TabNav :links="routesNav" @action="handleTabAction" />
    </div>
    <DocumentOrderAdminModal
      ref="documentOrderModal"
      @saved="onDocumentOrderSaved"
    />

    <div class="container-body">

      <div class="table-toolbar">
        <div class="toolbar-left">
          <label>
            Mostrar registros:
            <select v-model="pageSize" @change="onPageSizeChange">
              <option :value="10">10</option>
              <option :value="15">15</option>
              <option :value="25">25</option>
              <option :value="50">50</option>
              <option :value="100">100</option>
            </select>
          </label>
        </div>
        <div class="toolbar-right">
          <label>
            Buscar:
            <input
              type="text"
              v-model="searchQuery"
              @keyup="onSearchKeyup"
              placeholder="Buscar documento..."
            />
          </label>
        </div>
        <div class="toolbar-clear">
          <button
            v-if="hasActiveFilters"
            type="button"
            class="filters-clear-btn"
            @click="clearFilters"
          >
            Limpiar filtros
          </button>
        </div>
      </div>

      <!--Tabla de documentos-->
      <table class="docs-table">
        <!--Cabecera de tabla-->
        <thead>
          <tr>
            <th>#</th>
            <th class="sortable" @click="onSort('filename')">
              Nombre <font-awesome-icon :icon="getSortIcon('filename')"/>
            </th>
            <th class="sortable" @click="onSort('description')">
              Descripción <font-awesome-icon :icon="getSortIcon('description')"/>
            </th>
            <th class="groups-column">
              Grupos
            </th>
            <th class="action-column">
              Acción
            </th>
          </tr>
        </thead>
        <!--Cuerpo de tabla-->
        <tbody>
          <tr v-for="(item, index) in docs" :key="item.id">
            <td>{{ (currentPage - 1) * pageSize + index + 1 }}</td>
            <td>
              <a v-if="item.path" :href="contentUrl(item)" target="_blank" rel="noopener">
                {{ item.filename }}
              </a>
              <template v-else>{{ item.filename }}</template>
            </td>
            <td>{{ item.description }}</td>
            <td class="groups-cell">
              <div v-if="documentGroups(item).length" class="document-groups">
                <span
                  v-for="group in documentGroups(item).slice(0, maxVisibleGroups)"
                  :key="group.id"
                  class="document-group-chip"
                  :title="group.name"
                >
                  {{ group.name }}
                </span>
                <span
                  v-if="documentGroups(item).length > maxVisibleGroups"
                  class="document-group-more"
                  :title="hiddenGroupNames(item)"
                >
                  +{{ documentGroups(item).length - maxVisibleGroups }}
                </span>
              </div>
              <span v-else class="document-groups-empty">Sin grupo</span>
            </td>
            <td class="action-cell">
              <div class="action-cell__buttons">
                <router-link :to="'/documentos/' + item.id" class="btn-action btn-ver">
                  <font-awesome-icon icon="eye" /> Ver
                </router-link>
                <button
                  class="btn-action btn-toggle"
                  :disabled="togglingId === item.id"
                  :title="item.es_visible
                    ? 'Ocultar en Mapa > Ayuda (grupos asignados)'
                    : 'Mostrar en Mapa > Ayuda (grupos asignados)'"
                  @click="toggleVisibility(item)"
                >
                  <font-awesome-icon :icon="item.es_visible ? 'eye-slash' : 'eye'" />
                  {{ item.es_visible ? 'Ocultar en Ayuda' : 'Mostrar en Ayuda' }}
                </button>
                <router-link :to="'/documentos/' + item.id + '/editar-documento'" class="btn-action btn-edit">
                  Editar
                </router-link>
                <router-link :to="'/documentos/' + item.id + '/eliminar-documento'" class="btn-action btn-delete">
                  Eliminar
                </router-link>
              </div>
            </td>
          </tr>
          <!--Error-->
          <tr v-if="!hasDocuments">
            <td colspan="5">No hay documentos</td>
          </tr>
        </tbody>
      </table>

      <Pagination
        v-show="totalPages !== 0"
        :totalPages="totalPages"
        :currentPage="currentPage"
        :pageSize="pageSize"
        @pagechanged="pageChangedClick"
      />

    </div>
    <!-- <SideNav class="container-sidenav" :links="routesNav" /> -->
</main>
</template>
<script>
import SideNav from '@/components/SideNav.vue'
import Breadcrumb from '@/components/Breadcrumb.vue'
import TabNav from '@/components/TabNav.vue'
import Pagination from '@/components/Pagination.vue'
import DocumentOrderAdminModal from '@/views/documents/DocumentOrderAdminModal.vue'

import { formatter } from '@/components/mixin/formatter.js'
import { pagination } from '@/components/mixin/pagination.js'
import { restDocument } from '@/components/mixin/restDocument.js'

export default {
	mixins: [formatter, pagination, restDocument],
	components: { SideNav, Breadcrumb, Pagination, TabNav, DocumentOrderAdminModal },

	data (){
		return {
			loading: false,
			searchQuery: '',
			sortKey: '',
			sortOrder: 'asc',
			pageSize: 15,
			maxVisibleGroups: 3,
			debounceTimer: null,
			togglingId: null,
		}
	},
  computed: {
    routesNav() {
      return [
        {name: 'Opciones'},
        {name:'Nuevo', path:'/documentos/nuevo-documento'},
        {name:'Definir Orden', action: 'define-document-order', icon: 'sort'}
      ]
    },
    routesBread() {
      return [{ name: 'Documentos' }]
    },
    hasDocuments() {
      return this.docs.length > 0
    },
    hasActiveFilters() {
      return this.searchQuery !== '' || this.sortKey !== ''
    }
  },
  methods: {
    handleTabAction(action) {
      if (action === 'define-document-order') this.$refs.documentOrderModal.show()
    },
    onDocumentOrderSaved() {
      this.fetchDocuments()
      this.$store.dispatch('toast/show', {
        message: 'El orden de los documentos fue actualizado correctamente.',
        type: 'info'
      })
    },
    fetchDocuments() {
        this.getDocsPages(this.currentPage, this.searchQuery, this.sortKey, this.sortOrder, this.pageSize)
    },
    pageChangedClick(page) {
      this.currentPage = page
      this.fetchDocuments()
    },
    onPageSizeChange() {
      this.currentPage = 1
      this.fetchDocuments()
    },
    onSearchKeyup() {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        this.currentPage = 1
        this.fetchDocuments()
      }, 300)
    },
    onSort(key) {
      if (this.sortKey === key) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortKey = key
        this.sortOrder = 'asc'
      }
      this.currentPage = 1
      this.fetchDocuments()
    },
    getSortIcon(key) {
      if (this.sortKey !== key) return 'sort'
      return this.sortOrder === 'asc' ? 'sort-up' : 'sort-down'
    },
    clearFilters() {
      clearTimeout(this.debounceTimer)
      this.searchQuery = ''
      this.sortKey = ''
      this.sortOrder = 'asc'
      this.currentPage = 1
      this.fetchDocuments()
    },
    documentGroups(item) {
      const groupIds = Array.isArray(item.id_groups) ? item.id_groups : []
      return groupIds.map((idGroup) => {
        const group = this.groups.find((itemGroup) => itemGroup.id === idGroup)
        return group || { id: idGroup, name: 'Grupo desconocido' }
      })
    },
    hiddenGroupNames(item) {
      return this.documentGroups(item)
        .slice(this.maxVisibleGroups)
        .map((group) => group.name)
        .join(', ')
    },
    toggleVisibility(item) {
      this.togglingId = item.id
      this.toggleDocVisibility(item.id)
        .then(() => {
          this.$store.dispatch('toast/show', {
            message: item.es_visible ? 'Documento ocultado' : 'Documento ahora visible',
            type: 'info'
          })
          this.fetchDocuments()
        })
        .catch(() => {
          this.$store.dispatch('toast/show', {
            message: 'No es posible cambiar la visibilidad del documento',
            type: 'error'
          })
        })
        .finally(() => {
          this.togglingId = null
        })
    },
  },
  created () {
    this.$store.getters.getPermissions?.documents ? true : this.$router.push('/pagina-no-encontrada')
  },
  mounted() {
    this.fetchDocuments()
    this.getDocumentGroups().catch(() => {})
  }

}
</script>
<style lang="scss" scoped>
.table-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 1em;
  margin-bottom: 1em;
}

.table-toolbar label {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.toolbar-left,
.toolbar-center,
.toolbar-right,
.toolbar-clear{
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 0.75em;
}

.docs-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1em;
}
.docs-table th,
.docs-table td {
  padding: 0.6em 0.8em;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  text-align: left;
  vertical-align: middle;
  font-size: 0.875em;
}

.docs-table thead th {
  background: var(--color-navy);
  color: #fff;
  white-space: nowrap;
  font-weight: 600;
}

.docs-table th.sortable {
  cursor: pointer;
  user-select: none;
}

.docs-table th.sortable:hover {
  background: var(--color-steel);
}

.docs-table tbody tr:hover {
  background: rgba(59, 110, 148, 0.06);
}

.docs-table th.action-column,
.docs-table td.action-cell {
  width: 1%;
  white-space: nowrap;
  text-align: left;
}

/* Nombre/Descripción: un valor largo sin espacios (hasta 150/450
   caracteres, ver validateDocumentFields en el backend) debe envolver
   dentro de la celda en vez de ensanchar la tabla/página. table-layout es
   auto (columnas se reparten el ancho disponible), así que un max-width
   acá no limita la columna — overflow-wrap es lo que realmente evita el
   desborde horizontal. */
.docs-table td:nth-child(2),
.docs-table td:nth-child(3) {
  overflow-wrap: anywhere;
}

.action-cell__buttons {
  display: flex;
  flex-wrap: nowrap;
  gap: 0.4em;
  align-items: center;
  justify-content: flex-start;
  width: max-content;
}

.docs-table th.groups-column,
.docs-table td.groups-cell {
  min-width: 12rem;
}

.document-groups {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem;
}

.document-group-chip,
.document-group-more {
  display: inline-block;
  padding: 0.2em 0.55em;
  border-radius: 999px;
  background: #e8f0f6;
  color: var(--color-navy);
  font-size: 0.82em;
  line-height: 1.35;
  white-space: nowrap;
}

.document-group-chip {
  max-width: 11rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.document-group-more {
  background: var(--color-navy);
  color: #fff;
  cursor: help;
}

.document-groups-empty {
  color: var(--color-ghost);
  font-size: 0.82em;
}

.btn-action {
  display: inline-flex;
  align-items: center;
  gap: 0.25em;
  padding: 0.2em 0.55em;
  border-radius: 3px;
  font-size: 0.82em;
  font-weight: 500;
  text-decoration: none;
  white-space: nowrap;
  transition: opacity 0.12s;
  &:hover { opacity: 0.8; text-decoration: none; }
}

.btn-ver    { background: #e8f4fd; color: var(--color-navy); }
.btn-edit   { background: #fef9e7; color: #7d6608; }
.btn-delete { background: #fdf2f2; color: #922b21; }

/* Único btn-action sobre un <button>: necesita los resets que un <a> trae de
   fábrica para alinearse con los router-link vecinos. */
.btn-toggle {
  background: #eef2f5;
  color: #4a5a68;
  border: none;
  font-family: inherit;
  cursor: pointer;
  &:disabled { opacity: 0.5; cursor: not-allowed; }
}

</style>
